import defaultTemplate from './vd-suggestion.html'

/**
 * Controller for the vd-suggestion component that renders a single suggestion for the Autocomplete or
 * Dropdown components.
 *
 * @class SuggestionList
 */
export default class SuggestionController {
  constructor($element, $compile, $scope) {
    'ngInject'
    this._$element = $element
    this._$compile = $compile
    this._$scope = $scope
  }

  $onChanges() {
    // Create a new isolate scope to supply to the template - this enables us to limit what information we expose (i.e.
    // be explicit about what's API or not)
    if (!this._suggestionScope) {
      this._suggestionScope = this._$scope.$new(true)
    }

    // Expose the information we want to expose to the template on our isolate scope. Naming convention is $vdCamelCase.
    this._suggestionScope.$vdSuggestion = this.suggestion
    this._suggestionScope.$vdQuery = this.query
    this._suggestionScope.$vdSource = this.source
  }

  $postLink() {
    const template = this.source.getTemplate(this.suggestion)
    const compiledTemplate = this._$compile(template || defaultTemplate)
    this._$element.append(compiledTemplate(this._suggestionScope))
  }
}
